<form [formGroup]="form">
  <div class="autocomplete-container">
    <input
      #input
      type="text"
      class="form-input"
      [id]="id"
      [formControlName]="formControlName"
      [attr.placeholder]="placeholder"
      [required]="isRequired"
      bomAutofocusable
      (blur)="onBlur()"
    />
  </div>
</form>
